import { i18n } from "../../i18n";
import { MainMenu } from "./MainMenu";
import {
  DefaultSideMenuHeader,
  focusFirstSideMenuItem,
  updateSideMenuBody,
} from "./SideMenu";
import { MenuData, MenuDataItem } from "../../../types";
import { CategoryMenuItems } from "./CategoryMenuItems";
import { Icon } from "../Icon";

function getMenuData(): MenuData | null {
  const data = sessionStorage.getItem("preloadedNavJson");
  if (data) {
    return JSON.parse(data) as MenuData;
  } else {
    return null;
  }
}
interface CategoryMenuProps {
  currentItem?: MenuDataItem;
  handleBack?: () => void;
}

export const CategoryMenu = ({
  currentItem,
  handleBack,
}: CategoryMenuProps) => {
  const menuData = getMenuData();
  const backToMainMenu = () => updateSideMenuBody(<MainMenu />);

  const parentItem =
    menuData && currentItem && findParentById(menuData.items, currentItem.id);

  const updateMenu = (item: MenuDataItem) => {
    const handleBack = () => {
      const parentItem = menuData && findParentById(menuData.items, item.id);
      if (parentItem) {
        updateMenu(parentItem);
        focusFirstSideMenuItem();
      } else {
        updateSideMenuBody(<CategoryMenu />);
      }
    };

    if (item) {
      updateSideMenuBody(
        <CategoryMenu currentItem={item} handleBack={handleBack} />
      );
      focusFirstSideMenuItem();
    } else {
      updateSideMenuBody(<CategoryMenu />);
    }
  };

  const items = currentItem ? currentItem.items : menuData?.items;
  const title = currentItem
    ? currentItem.link.text
    : i18n("common.departments");

  const backToText = getBackToText(currentItem, parentItem);
  handleBack = handleBack ?? backToMainMenu;

  return (
    <>
      <DefaultSideMenuHeader />
      <article>
        <button
          type="button"
          onClick={handleBack}
          class="side-menu-item back-button"
        >
          <Icon name="chevron-left" />
          <span>{i18n("menu.back.to", backToText)}</span>
        </button>
        <section>
          <h4 class="overflow-ellipsis px-2">{title}</h4>
          {items && <CategoryMenuItems items={items} updateMenu={updateMenu} />}
        </section>
      </article>
    </>
  );
};

function getBackToText(
  currentItem: MenuDataItem | undefined,
  parentItem: MenuDataItem | undefined | null
): string {
  if (parentItem) return parentItem.link.text;
  if (currentItem) return i18n("common.departments");
  return i18n("menu.main.menu");
}

function findParentById(
  items: MenuDataItem[],
  id: string
): MenuDataItem | null {
  let parent = null;

  function search(items: MenuDataItem[]) {
    for (const item of items) {
      if (item.items && item.items.some((subItem) => subItem.id === id)) {
        parent = item;
        return true;
      }
      if (item.items && item.items.length > 0) {
        if (search(item.items)) {
          return true;
        }
      }
    }
    return false;
  }

  search(items);
  return parent;
}
